module.exports = __webpack_public_path__ + "static/media/isdoctorplan-spine-pain3.1cf704e1.png";